import React, { FC, ReactNode } from "react";

interface Props {
  title: string;
  description: string;
  url: string;
  dateAdded?: string;
  dateUpdated?: string;
  imagePath?: string;
  children?: ReactNode;
}

const SEO: FC<Props> = ({
  title,
  description,
  url,
  dateAdded,
  dateUpdated,
  imagePath,
  children,
}) => {
  const urlObject = new URL(url);
  const mainURL = urlObject.origin;
  const urlWithoutParameters = mainURL + urlObject.pathname;
  const nowISOString = new Date(new Date().getTime() + 9 * 60 * 60 * 1000)
    .toISOString()
    .replace("Z", "+09:00");
  const datePublished =
    dateAdded ?? new Date(2024, 3, 23).toISOString().replace("Z", "+09:00");
  const dateModified = dateUpdated ?? nowISOString;
  const ogImage = `${mainURL}${imagePath ?? "/icon.png"}`;
  return (
    <>
      <html lang="ja" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={urlWithoutParameters} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="コード進行メモ倉庫" />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="og:url" content={urlWithoutParameters} />
      {/*
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:image:alt" content={title} />
      */}
      <script type="application/ld+json">
        {`
            {
              "@context": "https://schema.org",
              "@type": "BlogPosting",
              "name": "コード進行メモ倉庫",
              "url": "${mainURL}",
              "headline" : "${title}",
              "image": ["${ogImage}"],
              "publisher" : {
                "@type" : "Organization",
                "name" : "コード進行メモ倉庫",
                "logo" : {
                  "@type" : "ImageObject",
                  "url" : "${mainURL}/icon.png",
                  "height" : "512",
                "width" : "512"
                }
              },
              "author" : {
                "@type" : "Organization",
                "name" : "コード進行メモ倉庫",
                "url": "${mainURL}/"
              },
              "mainEntityOfPage": "${urlWithoutParameters}",
              "description": "${description}",
              "datePublished" : "${datePublished}",
              "dateModified" : "${dateModified}"
            }
          `}
      </script>
      {children}
    </>
  );
};

export default SEO;
